(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["w1gk-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class W1gkAnnouncementBar extends HTMLElement {
  connectedCallback() {
    if (this.dataset.rotate !== 'true') return;

    const messages = this.querySelectorAll('[data-announcement-message]');
    if (messages.length < 2) return;

    const interval = Number.parseInt(this.dataset.interval, 10) || 5000;
    let index = 0;

    const show = (nextIndex) => {
      messages.forEach((el, i) => {
        const active = i === nextIndex;
        el.classList.toggle('is-active', active);
        el.toggleAttribute('hidden', !active);
      });
    };

    this.setAttribute('aria-live', 'polite');

    window.setInterval(() => {
      index = (index + 1) % messages.length;
      show(index);
    }, interval);
  }
}

if (!customElements.get('w1gk-announcement-bar')) {
  customElements.define('w1gk-announcement-bar', W1gkAnnouncementBar);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["w1gk-cta-slider"] && !Shopify.designMode) return;
  try {
    
  class W1gkCtaSlider extends HTMLElement {
    connectedCallback() {
      const slides = this.querySelectorAll('[data-cta-slide]');
      const dots = this.querySelectorAll('[data-cta-dot]');
      if (slides.length < 2) return;

      let index = 0;
      const autoplay = this.dataset.autoplay === 'true';
      const interval = Number.parseInt(this.dataset.interval, 10) || 6000;
      let timerId = null;

      const show = (nextIndex) => {
        index = nextIndex;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
        });
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const next = Number.parseInt(dot.dataset.index, 10);
          if (Number.isNaN(next)) return;
          show(next);
          if (autoplay) {
            window.clearInterval(timerId);
            timerId = window.setInterval(() => {
              show((index + 1) % slides.length);
            }, interval);
          }
        });
      });

      if (autoplay) {
        timerId = window.setInterval(() => {
          show((index + 1) % slides.length);
        }, interval);
      }
    }
  }

  if (!customElements.get('w1gk-cta-slider')) {
    customElements.define('w1gk-cta-slider', W1gkCtaSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["w1gk-featured-slider"] && !Shopify.designMode) return;
  try {
    
  class W1gkFeaturedSlider extends HTMLElement {
    connectedCallback() {
      const slides = this.querySelectorAll('[data-featured-slide]');
      const dots = this.querySelectorAll('[data-featured-dot]');
      const sectionRoot = this.closest('.w1gk-featured-slider');
      const counter = sectionRoot?.querySelector('[data-featured-counter]');
      const prevBtn = sectionRoot?.querySelector('[data-featured-prev]');
      const nextBtn = sectionRoot?.querySelector('[data-featured-next]');
      const slideCount = slides.length;
      if (slideCount < 1) return;

      let index = 0;
      const autoplay = this.dataset.autoplay === 'true';
      const interval = Number.parseInt(this.dataset.interval, 10) || 6000;
      let timerId = null;

      const updateCounter = () => {
        if (!counter) return;
        counter.textContent = `${index + 1} / ${slideCount}`;
      };

      const show = (nextIndex) => {
        index = (nextIndex + slideCount) % slideCount;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
        });
        dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        updateCounter();
      };

      const restartAutoplay = () => {
        if (!autoplay || slideCount < 2) return;
        window.clearInterval(timerId);
        timerId = window.setInterval(() => {
          show(index + 1);
        }, interval);
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const next = Number.parseInt(dot.dataset.index, 10);
          if (Number.isNaN(next)) return;
          show(next);
          restartAutoplay();
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          show(index - 1);
          restartAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          show(index + 1);
          restartAutoplay();
        });
      }

      updateCounter();

      if (autoplay && slideCount > 1) {
        timerId = window.setInterval(() => {
          show(index + 1);
        }, interval);
      }
    }
  }

  if (!customElements.get('w1gk-featured-slider')) {
    customElements.define('w1gk-featured-slider', W1gkFeaturedSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
